import { useState, useEffect, useContext } from "react";
import { Switch, VStack, HStack, Text, Image, useToast } from "@chakra-ui/react";
import { ethers } from "ethers";
import { AppContext } from "../../AppContext";
import BlindfoldWalletV2 from "../../contracts/BlindfoldWalletV2.json"; // Import contract ABI

const TokenStatusToggle = () => {
  const { fastestWebSocket, contractAddress } = useContext(AppContext);
  const provider = new ethers.providers.WebSocketProvider(fastestWebSocket);

  const [tokenStatuses, setTokenStatuses] = useState({});
  const toast = useToast();

  // **Updated Token List with Labels & Images**
  const tokens = [
    { key: "linkShort", label: "LINK Short", image: "/chainlink-icon.png" },
    { key: "linkLong", label: "LINK Long", image: "/chainlink-icon.png" },
    { key: "wethShort", label: "WETH Short", image: "/weth.png" },
    { key: "wethLong", label: "WETH Long", image: "/weth.png" },
    { key: "uniShort", label: "UNI Short", image: "/uni.png" },
    { key: "uniLong", label: "UNI Long", image: "/uni.png" },
    { key: "wbtcLong", label: "WBTC Long", image: "/btc.png" },
    { key: "wbtcShort", label: "WBTC Short", image: "/btc.png" }
  ];

  // **Fetch Token Statuses from Contract**
  const fetchTokenStatuses = async () => {
    try {
      const contract = new ethers.Contract(contractAddress, BlindfoldWalletV2.abi, provider);
      const statuses = {};

      for (const token of tokens) {
        const status = await contract.getTokenStatus(token.key);
        statuses[token.key] = status;
      }

      setTokenStatuses(statuses);
    } catch (error) {
      console.error("Error fetching token statuses:", error);
    }
  };

  useEffect(() => {
    fetchTokenStatuses();
  }, [contractAddress]);

  // **Toggle Token Status in Smart Contract**
  const toggleTokenStatus = async (tokenKey) => {
    try {
      const web3Provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = web3Provider.getSigner();
      const contract = new ethers.Contract(contractAddress, BlindfoldWalletV2.abi, signer);

      const newStatus = !tokenStatuses[tokenKey]; // Flip the status
      const tx = await contract.setTokenStatus(tokenKey, newStatus);
      await tx.wait();

      setTokenStatuses((prev) => ({
        ...prev,
        [tokenKey]: newStatus
      }));

      toast({
        title: "Token Status Updated",
        description: `${tokens.find(t => t.key === tokenKey)?.label} is now ${newStatus ? "enabled" : "disabled"}.`,
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      console.error("Error updating token status:", error);
      toast({
        title: "Transaction Failed",
        description: error.message || "Could not update token status.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <VStack spacing={4} align="start" fontFamily={'Sentinel'}>
      <Text fontWeight="bold">Manage Token Settings</Text>

      {/* Display Token Toggles with Images */}
      {tokens.map((token) => (
        <HStack key={token.key} spacing={3} w="full" justify="space-between">
          <HStack>
            <Image src={token.image} alt={token.label} boxSize="20px" />
            <Text>{token.label}</Text>
          </HStack>
          <Switch 
            isChecked={tokenStatuses[token.key] || false} 
            onChange={() => toggleTokenStatus(token.key)} 
            colorScheme="blue" 
          />
        </HStack>
      ))}
    </VStack>
  );
};

export default TokenStatusToggle;
